module.exports = __webpack_public_path__ + "static/media/user_icon.622846ef.svg";